package diana.soleil.design.iraniancanadienbazzar.core.model

/**
 * A ticket type on an event (`events/{id}/ticketTypes/{tid}`). Free ticketing only for now (the
 * issueTicket Function rejects paid events — organizer outlink covers those); `priceCents` is kept
 * for the paid future.
 */
data class TicketType(
    val id: String,
    val name: String,
    val priceCents: Long = 0,
    val quantityTotal: Int? = null,
    val quantitySold: Int = 0,
) {
    val remaining: Int? get() = quantityTotal?.let { (it - quantitySold).coerceAtLeast(0) }
    val soldOut: Boolean get() = remaining == 0
}

/**
 * An issued ticket (`tickets/{id}` — server-created ONLY via the issueTicket Function; rules deny all
 * client writes so [qrPayload]/[status] can't be forged). Event identity is snapshotted onto the
 * ticket so the wallet renders offline without N event lookups.
 */
data class Ticket(
    val id: String,
    val eventId: String,
    val ticketTypeId: String,
    val qty: Int,
    val qrPayload: String,
    val status: TicketStatus,
    val eventTitle: LocalizedText = LocalizedText(),
    val startsAtMillis: Long? = null,
    val venueName: String = "",
    val purchasedAtMillis: Long? = null,
)

enum class TicketStatus { Valid, Used, Refunded }
